import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

export const Wordmark = ({ className = "", compact = false }) => {
  const { t, path } = useI18n();
  return (
    <Link
      to={path("home")}
      data-testid="brand-wordmark"
      className={`group inline-flex items-center gap-3 ${className}`}
      aria-label="HR Creations"
    >
      <img
        src="/hr-creations-logo.png"
        alt=""
        aria-hidden="true"
        className="h-12 w-12 shrink-0 rounded-full ring-1 ring-[#C69A3B]/60 transition-transform duration-500 group-hover:scale-105 sm:h-14 sm:w-14"
      />
      <span className="leading-none">
        <span className="block font-serif-display text-lg sm:text-xl tracking-tight text-[#8F3329]">
          HR Creations
        </span>
        {!compact && <span className="label-mono mt-1 block">{t("brand.tagline")}</span>}
      </span>
    </Link>
  );
};

export const SectionHeading = ({ label, title, sub, align = "left" }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {label && <p className="label-mono mb-3">{label}</p>}
    <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#252525]">{title}</h2>
    {sub && <p className="mt-3 text-sm sm:text-base text-[#5A5752]">{sub}</p>}
    <div className="gold-rule mt-6 w-24" />
  </div>
);

export const GoldButton = ({ as: As = "button", children, variant = "primary", className = "", ...props }) => {
  const styles = {
    primary:
      "bg-[#8F3329] text-[#FAFAF7] border border-[#8F3329] hover:bg-[#752a21] hover:text-[#FAFAF7]",
    outline:
      "bg-transparent text-[#8F3329] border border-[#C69A3B] hover:bg-[#8F3329] hover:text-[#FAFAF7]",
    ghost: "bg-transparent text-[#252525] border border-transparent hover:text-[#8F3329]",
    light:
      "bg-[#FAFAF7]/95 text-[#252525] border border-[#FAFAF7]/60 hover:bg-[#C69A3B] hover:text-[#252525]",
  }[variant];
  return (
    <As
      className={`inline-flex min-h-[44px] items-center justify-center gap-2 px-6 py-3 text-sm font-medium tracking-wide transition-colors duration-300 ${styles} ${className}`}
      {...props}
    >
      {children}
    </As>
  );
};
